var _mask, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenSemiCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1029,
    height: 279,
    viewBox: "0 0 1029 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_176_2395",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029 519C1029 381.952 975.263 250.466 879.516 153.236C783.769 56.0061 653.785 0.924606 517.928 0.0115191C382.071 -0.901567 251.37 52.4278 154.347 148.362C57.3246 244.297 1.85598 375.048 0.0456764 512.084L514.5 519H1029Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1029 519C1029 381.952 975.263 250.466 879.516 153.236C783.769 56.0061 653.785 0.924606 517.928 0.0115191C382.071 -0.901567 251.37 52.4278 154.347 148.362C57.3246 244.297 1.85598 375.048 0.0456764 512.084L514.5 519H1029Z",
    fill: "url(#paint0_linear_176_2395)",
    stroke: "#70CC40",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_176_2395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_2395",
    x1: 514.907,
    y1: 181.673,
    x2: 514.907,
    y2: -117.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70CC40",
    stopOpacity: 0.19
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSemiCircle);
export default __webpack_public_path__ + "static/media/green-semi-circle.b3e42ae1cb295ccf88751eac5fc6b6d8.svg";
export { ForwardRef as ReactComponent };